import {Root} from "./store-root";
import {action, computed, observable, runInAction} from "mobx";
import * as _ from "lodash";
import {Currency} from "../models/currency";
import {Country, Lookup} from "../models/country";
import {LookupData} from "../api/data/data";
import {CurrencyLookup} from "../api/data/currencies";
import {DeliveryBranches} from "../api/data/deliveryBranches";
import { TransferType, TransferTypes } from "../models/transfer-type";

export const bankOnlyTrasnferType : TransferType[]=[
    {label:'Bank Transfer', id:TransferTypes.bank.toString()}]

export const allTransferTypes : TransferType[]=[
    {label:'Bank Transfer', id:TransferTypes.bank.toString()},
    {label:'Cash',  id:TransferTypes.cash.toString()} ]

export class LookupsStore {
    parent: Root;
    @observable countryRegistry: Country[] = [];
    @observable branchRegistry: Lookup[] = [];
    @observable isLoading = false;
    @observable lookupLoaded = false;
    @observable currencyRegistry: Currency[] = [];
    @observable transferTypes : TransferType[]=[
        {label:'Bank Transfer', id:TransferTypes.bank.toString()},
        {label:'Cash',  id:TransferTypes.cash.toString()} ]

    constructor(root: Root) {
        this.parent = root;
    }

    @action LoadCountries = async () => {
        LookupData.forEach((item) => {
            //get currency symbol, and currency name
            const currencyCode = item.currencyCode;
            const found = this.currencies.find(
                (currency) => currency.code === currencyCode
            );

            if (found) {
                let country = new Country();
                country.currencyCode = found!.code;
                country.currencyLabel = found!.name_plural;
                country.currencySymbol = found!.symbol;
                country.id = item.countryCode;
                country.label = item.countryName;
                country.value=item.countryCode;
                country.key=item.countryCode;
                this.countryRegistry.push(country);
            }
        });
    };

    @action LoadBranches = async () => {
        this.isLoading = true;
        try {
            runInAction("Loading Branches/Cities", () => {
                this.branchRegistry = DeliveryBranches;
            });
        } catch (error) {
            runInAction("Error loading the cities", () => {
                this.isLoading = false;
            });
        }
    };

    @action setTransferTypes (types : TransferType[]){
        this.transferTypes = [];
        this.transferTypes = types;
    }

    @computed get countries() {
        const sortedCountries = _.sortBy(
            this.countryRegistry,
            (item) => item.value
        );
        return sortedCountries;
    }

    @computed get cities() {
        const sortedCities = _.sortBy(
            Array.from(this.branchRegistry),
            (item) => item.label
        );
        return sortedCities;
    }

    @computed get currencies() {
        const sortedCurrency = _.sortBy(
            Array.from(this.currencyRegistry.values()),
            (item) => item.label
        );
        return sortedCurrency;
    }

    @action loadCurrencies = async () => {
        try {
            const fromBackend = CurrencyLookup;
            const items: Currency[] = _.valuesIn(fromBackend);
            console.log(items);
            runInAction("Loading Currencies", () => {
                this.currencyRegistry = items;
            });
        } catch (error) {
            runInAction("Error loading the currencies", () => {
            });
        }
    };

    @action loadLookups = async () => {
        if (this.lookupLoaded) return;
        this.loadCurrencies();
        Promise.all([
            this.LoadCountries(),
            this.LoadBranches(),

        ]).then(() => {
            console.log("finished loading lookups");
            runInAction(() => (this.lookupLoaded = true));
        });
    };

    @action setCountries = (countries: Lookup[]) => {
        this.countryRegistry = [];
        //this.countryRegistry = countries;
    };

    @action setBranches = (branches: Lookup[]) => {
        this.branchRegistry = [];
        this.branchRegistry = branches;
    };

    @computed get numberOfSelectedCountries() {
        return this.countryRegistry.filter((item: Lookup) => item.checked).length;
    }

    @computed get numberOfSelectedBranches() {
        return this.branchRegistry.filter((item: Lookup) => item.checked).length;
    }

    @action resetAllFilters = () => {
        this.countryRegistry.forEach((item) => (item.checked = false));
        this.branchRegistry.forEach((item) => (item.checked = false));

    };

    @computed get filters() {
        const countriesSelected = this.countryRegistry.filter((item) => item.checked).map(
            (item) => `Sending Country : ${item.label}`
        );
        const branchesSelected = this.branchRegistry.filter(
            (item) => item.checked
        ).map((item) => `Category : ${item.label}`);


        return countriesSelected.concat(
            branchesSelected
        );
    }
}
